import { declareVrunComponent } from '/vodalys/vvuejs/declareVrunComponent.mjs'

declareVrunComponent('webrtcPlayer.vrun.component', () => import('./WebrtcPlayer.vue'))
